export default __webpack_public_path__ + "static/media/data.c3e2f22b.webp";